<h1 mat-dialog-title>
    <span *ngIf="data.title; else elseBlock">{{data.title}}</span>
    <ng-template #elseBlock><span>Add Item</span></ng-template>
</h1>
<div mat-dialog-content *ngIf="this.data.scope === 'Global'">
    <mat-form-field>
        <mat-label>Enter a new Submenu name</mat-label>
        <input
            [attr.data-testid]="'submenu_name_text'"
            [formControl]="name"
            matInput
            placeholder="Start typing"
            required
        />
    </mat-form-field>

    <mat-form-field>
        <mat-label>Enter a new Submenu tag</mat-label>
        <input
            [attr.data-testid]="'submenu_id_text'"
            [formControl]="id"
            matInput
            placeholder="Start typing"
            (focusout)="submenuTagValidation()"
            required
        />
        <mat-error *ngIf="id.errors">
            Submenu tags can only contain capital letters, numbers, and underscores
        </mat-error>
    </mat-form-field>
    <div *ngIf="tagExists" class="mat-error">
        {{ errorMessage }}
    </div>
    <mat-form-field>
        <mat-label>Select a Submenu to Copy (Optional)</mat-label>
        <mat-select [formControl]="copyFromId" name="copyFromId">
            <mat-option
                *ngFor="let option of options"
                [attr.data-testid]="option.name + '_option'"
                [value]="option.id"
            >{{ option.id }}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="toggle-question" *ngIf="displayAddGlobal">
        <mat-slide-toggle
            [attr.data-testid]="'add_global_toggle'"
            [formControl]="addGlobal"
        ><span class="toggle-label">Add Global</span></mat-slide-toggle>
    </div>
</div>
<div mat-dialog-actions>
    <button
        [attr.data-testid]="'cancel_button'"
        mat-raised-button
        matTooltip="Cancel"
        class="button-color"
        (click)="cancelAddItem()"
    >Cancel</button>
    <button
        [attr.data-testid]="'ok_button'"
        class="button-color"
        [disabled]="tagExists || (isReadOnly$ | async) || isSaveDisabled() || id.invalid"
        mat-raised-button
        matTooltip="Save"
        (click)="addItem()"
    >Ok</button>
</div>
